module.exports = __webpack_public_path__ + "img/wallet_green.c8b5a68e.svg";